const docsBaseUrl = import.meta.env?.VITE_DOCS_LINKS_BASE_URL || 'https://docs.sesam.io';

export const Links = {
  BuildingBlocksDatasetsDocumentation: `${docsBaseUrl}/hub/documentation/building-blocks/datasets.html`,
  BuildingBlocksPipesDocumentation: `${docsBaseUrl}/hub/documentation/building-blocks/pipes.html`,
  BuildingBlocksSystemsDocumentation: `${docsBaseUrl}/hub/documentation/building-blocks/systems.html`,
  FallbackPortalUrl: 'https://portal.sesam.in',
  HopsDTLReferenceGuideDocumentation: `${docsBaseUrl}/hub/dtl/dtl-functions-hops.html`,
  HttpWikipedia: 'https://en.wikipedia.org/wiki/Hypertext_Transfer_Protocol#HTTP_session_state',
  IntegratedSearchDocumentation: `${docsBaseUrl}/hub/features/integrated-search.html`,
  MailToInfoAtSesamDotIO: 'mailto:info@sesam.io',
  MailToSupportAtSesamDotIO: 'mailto:support@sesam.io',
  NetWorkPolicyDocumentation: `${docsBaseUrl}/hub/features/network-policy.html`,
  PrivacyPolicy: `${docsBaseUrl}/privacy-policy.html`,
  PumpUpdateLastSeenDocumentation: `${docsBaseUrl}/api.html#api-reference-pump-update-last-seen`,
  QuickReferenceDocumentation: `${docsBaseUrl}/quick-reference.html`,
  SchemaInferenceDocumentation: `${docsBaseUrl}/hub/features/schema-inference.html`,
  SesamChangeLog: `${docsBaseUrl}/changelog.html`,
  SesamDocumentations: `${docsBaseUrl}`,
  SesamPrices: `${docsBaseUrl}/pricing.html`,
  MetricsAndMonitoring: `${docsBaseUrl}/hub/features/metrics-api.html`,
  SesamSupport: 'https://support.sesam.io/hc',
  TermsOfService: `${docsBaseUrl}/terms.html`,
  TermsOfServicePDF: `${docsBaseUrl}/_downloads/2145e3633a91bd9e637d934af5616453/sesam-cloud-service-contract.pdf`,
};
